import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  calculateDistance,
  getCurrentLocation,
  padZero,
} from "../../util/util";
import { useLocation, useNavigate } from "react-router-dom";
import StoreController, { StoreType } from "../../controller/StoreController";
import OrderController from "../../controller/OrderController";

const MainMap = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location.state?.orderData;
  const currentTime = new Date();

  let renderInterval: any;

  const [currentRoute, setCurrentRoute] = useState<number>(0);
  const [storeInfo, setStoreInfo] = useState<StoreType>();

  const [isArrive, setIsArrive] = useState<boolean>(false);

  const route = [
    {
      current_position: "강남구 봉은사로25길",
      distance: 2400,
      route_distance: 120,
      guidance: "좌회전",
      order_status: 1,
      duration: 0,
    },
    {
      current_position: "강남구 봉은사로",
      distance: 2180,
      route_distance: 300,
      guidance: "좌회전",
      order_status: 1,
      duration: 2,
    },
    {
      current_position: "강남구 봉은사로",
      distance: 1800,
      route_distance: 440,
      guidance: "강남세브란스 방면으로 우회전",
      order_status: 2,
      duration: 3,
    },
    {
      current_position: "강남구 봉은사로",
      distance: 1460,
      route_distance: 100,
      guidance: "강남세브란스 방면으로 우회전",
      order_status: 2,
      duration: 5,
    },
    {
      current_position: "강남구 언주로",
      distance: 1300,
      route_distance: 840,
      guidance: "우회전",
      order_status: 2,
      duration: 6,
    },
    {
      current_position: "강남구 언주로",
      distance: 1080,
      route_distance: 620,
      guidance: "우회전",
      order_status: 3,
      duration: 8,
    },
    {
      current_position: "강남구 언주로",
      distance: 960,
      route_distance: 500,
      guidance: "우회전",
      order_status: 3,
      duration: 10,
    },
    {
      current_position: "강남구 언주로",
      distance: 740,
      route_distance: 280,
      guidance: "우회전",
      order_status: 3,
      duration: 12,
    },
    {
      current_position: "강남구 언주로",
      distance: 530,
      route_distance: 90,
      guidance: "우회전",
      order_status: 3,
      duration: 15,
    },
    {
      current_position: "강남구 테헤란로",
      distance: 400,
      route_distance: 400,
      guidance: "우회전",
      order_status: 3,
      duration: 17,
    },
    {
      current_position: "강남구 테헤란로",
      distance: 120,
      route_distance: 120,
      guidance: "우회전",
      order_status: 3,
      duration: 19,
    },
    {
      current_position: "강남구 테헤란로48길",
      distance: 0,
      route_distance: 0,
      guidance: "목적지",
      order_status: 4,
      duration: 20,
    },
  ];

  // const route = [
  //   {
  //     current_position: "강남구 봉은사로25길",
  //     distance: 2400,
  //     route_distance: 120,
  //     guidance: "좌회전",
  //     order_status: 1,
  //     duration: 0,
  //     x: -0.177,
  //     y: -0.21,
  //     rotate: 16.5,
  //   },
  //   {
  //     current_position: "강남구 봉은사로",
  //     distance: 2180,
  //     route_distance: 300,
  //     guidance: "좌회전",
  //     order_status: 1,
  //     duration: 2,
  //     x: -0.177,
  //     y: -0.14,
  //     rotate: 16.5,
  //   },
  //   {
  //     current_position: "강남구 봉은사로",
  //     distance: 1800,
  //     route_distance: 440,
  //     guidance: "강남세브란스 방면으로 우회전",
  //     order_status: 2,
  //     duration: 3,
  //     x: -0.13,
  //     y: -0.388,
  //     rotate: -73.5,
  //   },
  //   {
  //     current_position: "강남구 봉은사로",
  //     distance: 1460,
  //     route_distance: 100,
  //     guidance: "강남세브란스 방면으로 우회전",
  //     order_status: 2,
  //     duration: 5,
  //     x: -0.13,
  //     y: -0.306,
  //     rotate: -73.5,
  //   },
  //   {
  //     current_position: "강남구 봉은사로",
  //     distance: 1460,
  //     route_distance: 100,
  //     guidance: "강남세브란스 방면으로 우회전",
  //     order_status: 2,
  //     duration: 5,
  //     x: -0.13,
  //     y: -0.23,
  //     rotate: -73.5,
  //   },
  //   {
  //     current_position: "강남구 언주로",
  //     distance: 1300,
  //     route_distance: 840,
  //     guidance: "우회전",
  //     order_status: 2,
  //     duration: 6,
  //     x: -0.234,
  //     y: -0.43,
  //     rotate: -163.5,
  //   },
  //   {
  //     current_position: "강남구 언주로",
  //     distance: 1080,
  //     route_distance: 620,
  //     guidance: "우회전",
  //     order_status: 3,
  //     duration: 8,
  //     x: -0.234,
  //     y: -0.33,
  //     rotate: -163.5,
  //   },
  //   {
  //     current_position: "강남구 언주로",
  //     distance: 960,
  //     route_distance: 500,
  //     guidance: "우회전",
  //     order_status: 3,
  //     duration: 10,
  //     x: -0.234,
  //     y: -0.23,
  //     rotate: -163.5,
  //   },
  //   {
  //     current_position: "강남구 언주로",
  //     distance: 740,
  //     route_distance: 280,
  //     guidance: "우회전",
  //     order_status: 3,
  //     duration: 12,
  //     x: -0.234,
  //     y: -0.124,
  //     rotate: -163.5,
  //   },
  //   {
  //     current_position: "강남구 언주로",
  //     distance: 530,
  //     route_distance: 90,
  //     guidance: "우회전",
  //     order_status: 3,
  //     duration: 15,
  //     x: -0.478,
  //     y: -0.24,
  //     rotate: -68.5,
  //   },
  //   {
  //     current_position: "강남구 테헤란로",
  //     distance: 400,
  //     route_distance: 400,
  //     guidance: "우회전",
  //     order_status: 3,
  //     duration: 17,
  //     x: -0.478,
  //     y: -0.13,
  //     rotate: -68.5,
  //   },
  // ];

  const getStoreInfo = async () => {
    try {
      const oParams = {
        store_id: orderData.payment_store_id,
      };
      const oRes = await StoreController.getMenu(oParams);

      if (oRes && oRes.data) {
        console.log("getMenu", oRes.data);
        setStoreInfo(oRes.data.content);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const setArrive = () => {
    if (!isArrive) {
      setIsArrive(true);
    }
    // else if (isArrive && currentRoute === 11) navigate("/", { replace: true });
    OrderController.sendCurrentLocation({
      lon: 127.0551030887,
      lat: 37.5079292997,
      user_id: 17,
      platform_os: "OBIGO WEB OS",
    });
  };

  useEffect(() => {
    renderInterval = setInterval(() => {
      if (currentRoute === 4) {
        OrderController.sendCurrentLocation({
          lon: 127.05400428867843,
          lat: 37.50771319988305,
          user_id: 17,
          platform_os: "OBIGO WEB OS",
        });
      } else if (currentRoute === 10) {
        OrderController.sendCurrentLocation({
          lon: 127.0551030887,
          lat: 37.5079292997,
          user_id: 17,
          platform_os: "OBIGO WEB OS",
        });
      }

      if (currentRoute < 11) setCurrentRoute(currentRoute + 1);
    }, 1500);
    return () => {
      clearInterval(renderInterval);
    };
  }, [currentRoute]);

  useEffect(() => {
    if (orderData) {
      getStoreInfo();
    }
  }, []);

  return (
    <Style>
      <div className="wrapper">
        <img
          src={`${process.env.PUBLIC_URL}/img/route${currentRoute + 1}.png`}
          alt="route"
        />
        {/* <img
          className="map"
          src={`${process.env.PUBLIC_URL}/img/route.png`}
          alt="route"
          style={{
            transform: `translate(${route[currentRoute].x * 4000}px, ${
              route[currentRoute].y * 4500
            }px) rotate(${route[currentRoute].rotate}deg)`,
          }}
        /> */}
        <div className="clock">
          <h1>
            {padZero(
              new Date(
                currentTime.getTime() +
                  Math.round(
                    (orderData.payment_arrival_time / 12) * currentRoute
                  ) *
                    60 *
                    1000
              ).getHours()
            )}{" "}
            :{" "}
            {padZero(
              new Date(
                currentTime.getTime() +
                  Math.round(
                    (orderData.payment_arrival_time / 12) * currentRoute
                  ) *
                    60 *
                    1000
              ).getMinutes()
            )}
            <span>
              {" "}
              {new Date(
                currentTime.getTime() +
                  Math.round(
                    (orderData.payment_arrival_time / 12) * currentRoute
                  ) *
                    60 *
                    1000
              ).getHours() < 12
                ? "AM"
                : "PM"}
            </span>
          </h1>
        </div>
        <div className="guideWrap">
          <div className="guide">
            <img src={`${process.env.PUBLIC_URL}/img/Flag.png`} alt="flag" />
            <div>
              <h1>
                {route[currentRoute].route_distance > 1000
                  ? (route[currentRoute].route_distance / 1000).toFixed(1)
                  : Math.round(route[currentRoute].route_distance / 10) * 10}
                <span>
                  {" "}
                  {route[currentRoute].route_distance > 1000 ? "km" : "m"}
                </span>
              </h1>
              <h4>{route[currentRoute].guidance}</h4>
            </div>
          </div>
          <div className="storeInfoWrap">
            <div className="titleWrap">
              <h1>{storeInfo ? storeInfo.store_name : ""}</h1>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_small_arrow_right.svg`}
                alt="right_arrow"
              />
            </div>
            <div>
              <div className="bar" />
              <div className="progressWrap">
                <div className="progressItem">
                  <div
                    className={`progress ${
                      route[currentRoute].order_status > 0 && "active"
                    }`}
                  >
                    {route[currentRoute].order_status > 0 ? (
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_check.svg`}
                        alt="check"
                      />
                    ) : (
                      <h2>1</h2>
                    )}
                  </div>
                  <h3>접수대기</h3>
                </div>
                <div className="progressItem">
                  <div
                    className={`progress ${
                      route[currentRoute].order_status > 1 && "active"
                    }`}
                  >
                    {route[currentRoute].order_status > 1 ? (
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_check.svg`}
                        alt="check"
                      />
                    ) : (
                      <h2>2</h2>
                    )}
                  </div>
                  <h3>주문시작</h3>
                </div>
                <div className="progressItem">
                  <div
                    className={`progress ${
                      route[currentRoute].order_status > 2 && "active"
                    }`}
                  >
                    {route[currentRoute].order_status > 2 ? (
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_check.svg`}
                        alt="check"
                      />
                    ) : (
                      <h2>3</h2>
                    )}
                  </div>
                  <h3>준비완료</h3>
                </div>
                <div className="progressItem">
                  <div
                    className={`progress ${
                      route[currentRoute].order_status > 3 &&
                      isArrive &&
                      "active"
                    }`}
                  >
                    {route[currentRoute].order_status > 3 && isArrive ? (
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_check.svg`}
                        alt="check"
                      />
                    ) : (
                      <h2>4</h2>
                    )}
                  </div>
                  <h3>픽업완료</h3>
                </div>
              </div>
            </div>
            <div className="wideWrap">
              <div className="contentWrap">
                <div className="content">
                  <div className="contentBox">
                    <img
                      src={
                        storeInfo && storeInfo.store_parking_image !== null
                          ? storeInfo.store_parking_image
                          : `${process.env.PUBLIC_URL}/svg/ic_none_image.svg`
                      }
                      alt="parkImg"
                    />
                  </div>
                  <h3>픽업존</h3>
                </div>
                <div className="content">
                  <div className="contentBox border">
                    <h3>
                      {orderData
                        ? `${
                            (
                              Object.values(orderData.payment_basket) as any
                            )[0][0].prd_name
                          }
                        ${
                          (Object.values(orderData.payment_basket) as any)[0]
                            .length -
                            1 >
                          0
                            ? `\n외 ${
                                (
                                  Object.values(orderData.payment_basket) as any
                                )[0].length - 1
                              }개`
                            : ""
                        }`
                        : ""}
                    </h3>
                  </div>
                  <h3>주문내역</h3>
                </div>
              </div>
              <button onClick={setArrive}>
                <h2>도착완료</h2>
              </button>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="totalWrap">
            <h3>
              {route[currentRoute].distance > 1000
                ? (route[currentRoute].distance / 1000).toFixed(1)
                : route[currentRoute].distance}{" "}
              <span>{route[currentRoute].distance > 1000 ? "km" : "m"}</span>
            </h3>
            <h3>
              {padZero(
                new Date(
                  currentTime.getTime() +
                    orderData.payment_arrival_time * 60 * 1000
                ).getHours()
              )}{" "}
              :{" "}
              {padZero(
                new Date(
                  currentTime.getTime() +
                    orderData.payment_arrival_time * 60 * 1000
                ).getMinutes()
              )}
              <span>
                {" "}
                {new Date(
                  currentTime.getTime() +
                    orderData.payment_arrival_time * 60 * 1000
                ).getHours() < 12
                  ? "AM"
                  : "PM"}
              </span>
            </h3>
          </div>
          <div className="destination">
            <h2>{route[currentRoute].current_position}</h2>
          </div>
        </div>
      </div>
    </Style>
  );
};

export default MainMap;

const Style = styled.div`
  .wrapper {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    img.map {
      width: 4000px;
      height: auto;
      transition: transform 1.2s ease;
    }
  }
  .customoverlay {
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
    .img {
      width: 60px;
      height: 60px;
    }
  }

  h1 {
    font-size: 60px;
    line-height: 60px;
    color: #ffffff;
    span {
      font-size: 24px;
    }
  }
  h2 {
    font-size: 44px;
    line-height: 44px;
    font-weight: 500;
    color: #ffffff;
  }
  h3 {
    font-size: 40px;
    line-height: 40px;
    font-weight: 500;
    color: #ffffff;
    span {
      font-size: 20px;
    }
  }
  h4 {
    font-size: 28px;
    line-height: 28px;
    font-weight: 500;
    color: #ffffff;
  }

  .clock {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background: #000000bf;
    z-index: 10;
    width: 280px;
    padding-top: 10px;
    border-radius: 0 0 5px 5px;
    text-align: center;
  }
  .guideWrap {
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 85%;
    background: #000000bf;
    border-radius: 5px 0 0 5px;
    z-index: 10;
    .guide {
      display: flex;
      align-items: center;
      padding: 0 8% 0 2%;
      background: #5b5e5b;
      height: 20%;
      img {
        width: auto;
        height: 100%;
      }
      h4 {
        line-height: 18px;
      }
    }
    .storeInfoWrap {
      height: 80%;
      padding: 20px 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 20px;
      .titleWrap {
        display: flex;
        align-items: center;
        gap: 10px;
        h1 {
          max-width: 400px;
          font-size: 36px;
          line-height: 50px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        img {
          width: auto;
          height: 50px;
        }
      }
      .progressWrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .progressItem {
          display: flex;
          flex-direction: column;
          align-items: center;
          .progress {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50px;
            width: 44px;
            height: 44px;
            z-index: 1;
            background: #ffffff;
            h2 {
              font-size: 28px;
              color: #333333;
              font-weight: 600;
            }
          }
          .progress.active {
            background: #5991ff;
          }
          img {
            width: auto;
            height: auto;
          }
          h3 {
            font-size: 20px;
            line-height: 44px;
            font-weight: 600;
          }
        }
      }
      .bar {
        width: 90%;
        height: 4px;
        background: #ffffff;
        margin: 20px 20px -24px 20px;
      }
      .contentWrap {
        display: flex;
        align-items: center;
        gap: 20px;
        .content {
          flex: 1;
          text-align: center;
          .contentBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            height: 120px;
            background: #000000;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .contentBox.border {
            border: 1px solid #ffffff;
            background: none;
          }
          h3 {
            font-size: 18px;
            line-height: 30px;
            font-weight: 600;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: pre-line;
          }
        }
      }
      button {
        width: 100%;
        padding: 16px 0;
        text-align: center;
        border-radius: 10px;
        background: linear-gradient(
          180deg,
          #5d88de 0%,
          #09276e 100%,
          #8c8c8c 100.01%
        );
        h2 {
          font-size: 28px;
          line-height: 40px;
          font-weight: 600;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 15%;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    gap: 1%;
    z-index: 10;
    .totalWrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 20%;
      height: 100%;
      background: #000000bf;
      border-radius: 5px;
      padding: 0 2%;
      text-align: right;
    }
    .destination {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      background: #000000af;
      border-radius: 5px;
      padding: 0 2%;
    }
  }
  .wideWrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  @media (max-width: 1400px) {
    h1 {
      font-size: 3.5rem;
      line-height: 3.5rem;
      span {
        font-size: 2rem;
      }
    }
    h2 {
      font-size: 2.4rem;
      line-height: 2.4rem;
    }
    h3 {
      font-size: 2.3rem;
      line-height: 2.3rem;
      span {
        font-size: 1.5rem;
      }
    }
    h4 {
      font-size: 2rem;
      line-height: 2rem;
    }

    .clock {
      width: auto;
      padding: 10px 20px 4px 20px;
      z-index: 11;
    }
    .guideWrap {
      top: 0;
      right: auto;
      width: 100%;
      height: auto;
      border-radius: 5px 5px 0 0;
      .guide {
        position: fixed;
        bottom: 8.5%;
        width: 100%;
        padding: 2% 4%;
        height: auto;
        gap: 20px;
        h1 {
          font-size: 3rem;
        }
        h4 {
          line-height: 2rem;
        }
      }
      .storeInfoWrap {
        flex: 1;
        padding: 8% 4% 2% 4%;
        display: flex;
        justify-content: space-between;
        gap: 16px;
        .titleWrap {
          display: flex;
          align-items: center;
          gap: 10px;
          h1 {
            max-width: 400px;
            font-size: 2.2rem;
            line-height: 3rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          img {
            width: auto;
            height: 50px;
          }
        }
        .progressWrap {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .progressItem {
            display: flex;
            flex-direction: column;
            align-items: center;
            .progress {
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50px;
              width: 44px;
              height: 44px;
              z-index: 1;
              background: #ffffff;
              h2 {
                font-size: 28px;
                color: #333333;
                font-weight: 600;
              }
            }
            .progress.active {
              background: #5991ff;
            }
            img {
              width: auto;
              height: auto;
            }
            h3 {
              font-size: 20px;
              line-height: 44px;
              font-weight: 600;
            }
          }
        }
        .bar {
          width: 95%;
        }
        .contentWrap {
          flex: 1;
          gap: 12px;
          .content {
            .contentBox {
              height: 140px;
            }
            h3 {
              font-size: 1.5rem;
              line-height: 2rem;
            }
          }
        }
        button {
          width: auto;
          padding: 0 18px;
          margin-bottom: 2rem;
          h2 {
            font-size: 2rem;
            line-height: 2rem;
          }
        }
      }
    }
    .footer {
      height: 8%;
      z-index: 10;
      .totalWrap {
        width: 25%;
      }
    }
    .wideWrap {
      flex-direction: row;
      gap: 12px;
    }
  }
`;
